// TOUR-19 — Ops deal paperwork pulse (lifecycle gaps / checklist).

import { OPS_REVIEWER_ROLES } from "@/lib/roles/turboOpsRoles";
import type { FireflyTourArtifact } from "../tourTypes";

export const OPS_PAPERWORK_TOUR_ID = "tour-ops-paperwork";

export const OPS_PAPERWORK_TOUR: FireflyTourArtifact = {
  id: OPS_PAPERWORK_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "ops tour",
    "missing paperwork",
    "deal checklist",
    "operations tour",
    "paperwork tour",
    "walk me through ops paperwork",
    "show me deal paperwork",
    "how do i check deal paperwork",
  ],
  bucketRelevance: ["ops"],
  requiredRoles: [...OPS_REVIEWER_ROLES],
  steps: [
    {
      id: "nav-operations",
      target: {
        mode: "operations",
        anchorId: "mode-nav-operations",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "operations",
      copy: {
        title: "Open Deals",
        body: "Deal checklists, overdue paperwork, and ops tasks live here. Tap Deals in the Ops bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "paperwork-surface",
      target: {
        mode: "operations",
        anchorId: "ops-paperwork-surface",
        scrollIntoView: true,
      },
      copy: {
        title: "Deals",
        body: "This surface tracks post-sale deal paperwork — checklists, evidence links, tasks, and the inventory-host webhook timeline.",
      },
      advanceOn: "next_button",
    },
    {
      id: "missing-paperwork",
      target: {
        mode: "operations",
        anchorId: "ops-missing-paperwork",
        scrollIntoView: true,
      },
      copy: {
        title: "Missing / overdue pulse",
        body: "The clipboard count is overdue paperwork items across deals. Non-zero means something still needs evidence, a status update, or a due-date catch-up.",
      },
      advanceOn: "next_button",
    },
    {
      id: "deals-tab",
      target: { mode: "operations", anchorId: "ops-deals-tab", scrollIntoView: true },
      copy: {
        title: "Deals tab",
        body: "Stay on Deals for the deal list and per-deal checklist. Tasks and notifications are available to more roles; deal management needs an ops-capable role.",
      },
      waitForClick: true,
    },
    {
      id: "deals-list",
      target: { mode: "operations", anchorId: "ops-deals-list", scrollIntoView: true },
      copy: {
        title: "Deal list",
        body: "Each row shows status and paperwork done/total. Tap a deal to open its checklist — create + seed is optional and not part of this walkthrough.",
      },
      waitForClick: true,
    },
    {
      id: "deal-checklist",
      target: {
        mode: "operations",
        anchorId: "ops-deal-checklist",
        scrollIntoView: true,
      },
      copy: {
        title: "Deal checklist",
        body: "Checklist rows move through missing → waived / received / verified. Attach evidence URLs or files per row. You update statuses yourself — the tour will not change paperwork.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "operations", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "RTO terms for Sales Console live under a sibling Ops mode. Ask Firefly anytime for intake review or other mode tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
